import { parse } from 'query-string';

function getMFTestVersionFromURLParams() {
    const queryParams = parse(window.location.search);
    return queryParams.mf_test_version;
}

export { getMFTestVersionFromURLParams };
